import { ConsiderationDao } from '@rock/db-admin';
import type { ConsiderationTypeId, HomeId } from '@rock/types';
import { shallowEqual } from '@rock/util';
import { atomFamily } from 'jotai/utils';

const considerationDao = new ConsiderationDao();

/** One home's considerations (single home-level subscription) — group by typeId client-side. */
export const considerationsForHomeState = atomFamily(
    (homeId: HomeId | undefined) => considerationDao.considerationsForHomeAtom(homeId),
    shallowEqual,
);

export const considerationsForConsiderationTypeState = atomFamily(
    (considerationTypeId: ConsiderationTypeId | undefined) =>
        considerationDao.considerationsForConsiderationTypeAtom(considerationTypeId),
    shallowEqual,
);
